import axios from 'axios';
import { SCREENINGS_API } from '../env.config.js';

const fetchTemplateData = async (token, templateId, language, providerId) => {
  const baseURL = SCREENINGS_API;
  const templateConfig = {
    params: {
      'template_format': 'surveyjs',
      'language': language,
      'redirect_to_active': true
    },
    baseURL,
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Scope-Id': providerId
    },
  };

  const response = await axios.get(`templates/${templateId}`, templateConfig);
  const template = response.data;

  return template;
};

export default fetchTemplateData;
